/* Penrose Skin : remplace le moteur de l'app Instant (absente de cette boutique).
   window.Instant.api (addToCart, toggleCart, updateLine, updateCart, applyDiscount) sur l'API panier AJAX de Shopify,
   tiroir panier rafraichi par l'API Section Rendering (regions [data-cart-update] de la section pr-cart),
   panneaux [data-overlay], menus [data-menu], en-tete collant, cadeau « pot voyage » des 3 pots. */
(function () {
  var PR = window.PR || {};
  var JSONH = { 'Content-Type': 'application/json', Accept: 'application/json' };

  function busy(btn, on) {
    if (!btn) return;
    if (on) { btn.setAttribute('aria-busy', 'true'); btn.disabled = true; }
    else { btn.removeAttribute('aria-busy'); btn.disabled = false; }
  }

  function post(url, body) {
    return fetch(url, { method: 'POST', headers: JSONH, body: JSON.stringify(body) }).then(function (r) {
      return r.json().then(function (j) { return { ok: r.ok, json: j }; }, function () { return { ok: r.ok, json: null }; });
    });
  }

  function getCart() { return fetch('/cart.js', { headers: JSONH }).then(function (r) { return r.json(); }); }

  // Re-rend la section pr-cart et remplace chaque region [data-cart-update] ; met a jour les pastilles du panier.
  function refresh() {
    var sec = PR.cartSection || 'pr-cart';
    var url = window.location.pathname + '?sections=' + sec;
    return Promise.all([fetch(url).then(function (r) { return r.json(); }), getCart()]).then(function (res) {
      var html = res[0][sec];
      if (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        doc.querySelectorAll('[data-cart-update]').forEach(function (fresh) {
          var key = fresh.getAttribute('data-cart-update');
          document.querySelectorAll('[data-cart-update="' + key + '"]').forEach(function (cur) { cur.innerHTML = fresh.innerHTML; });
        });
      }
      document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = res[1].item_count; });
      document.dispatchEvent(new CustomEvent('pr:cart', { detail: res[1] }));
      return res[1];
    });
  }

  // 3 pots ou plus -> le pot voyage est dans le panier (offert par la remise automatique) ; moins de 3 -> retire.
  var reconciling = false;
  function reconcile(cart) {
    if (!PR.gift || reconciling) return Promise.resolve(cart);
    var jars = 0, gift = null;
    cart.items.forEach(function (it) {
      if (it.variant_id === PR.gift) gift = it;
      else if (it.product_type === PR.jarType) jars += it.quantity;
    });
    var step = null;
    if (jars >= 3 && !gift) step = post('/cart/add.js', { items: [{ id: PR.gift, quantity: 1, properties: PR.giftProps || { 'Cadeau': 'Offert dès 3 pots' } }] });
    else if (jars < 3 && gift) step = post('/cart/change.js', { id: gift.key, quantity: 0 });
    else if (gift && gift.quantity > 1) step = post('/cart/change.js', { id: gift.key, quantity: 1 });
    if (!step) return Promise.resolve(cart);
    reconciling = true;
    return step.then(function () { reconciling = false; return refresh(); });
  }

  function sync() { return refresh().then(reconcile); }

  function toggleCart(open) {
    var o = document.querySelector('[data-cart-overlay]');
    if (!o) return;
    var on = open === undefined ? o.getAttribute('data-state') !== 'open' : !!open;
    o.setAttribute('data-state', on ? 'open' : 'closed');
    document.documentElement.classList.toggle('pr-lock', on);
  }

  var api = {
    addToCart: function (lines, opts) {
      opts = opts || {};
      var items = (Array.isArray(lines) ? lines : [lines]).filter(function (l) { return l && String(l.id) !== '57993123594627'; }).map(function (l) {
        var it = { id: Number(l.id), quantity: l.quantity || 1 };
        if (l.properties) it.properties = l.properties;
        return it;
      });
      busy(opts.button, true);
      return post('/cart/add.js', { items: items }).then(function (r) {
        return sync().then(function () {
          busy(opts.button, false);
          if (r.ok && opts.openCart !== false) toggleCart(true);
          if (!r.ok && r.json && r.json.description) window.alert(r.json.description);
          return { success: r.ok };
        });
      }, function () { busy(opts.button, false); return { success: false }; });
    },
    toggleCart: toggleCart,
    updateLine: function (key, o) { return post('/cart/change.js', { id: key, quantity: o.quantity }).then(sync); },
    updateCart: function (body) { return post('/cart/update.js', body).then(sync); },
    applyDiscount: function () { return Promise.resolve({ applied: false }); },
    refresh: sync
  };
  window.Instant = window.Instant || {};
  window.Instant.api = api;

  // ------------------------------------------------------------------ delegation
  document.addEventListener('click', function (e) {
    var t = e.target;
    var open = t.closest('[data-overlay-open]');
    if (open) {
      var ov = document.querySelector('[data-overlay="' + open.getAttribute('data-overlay-open') + '"]');
      if (ov) { e.preventDefault(); ov.setAttribute('data-state', 'open'); document.documentElement.classList.add('pr-lock'); }
      return;
    }
    var close = t.closest('[data-overlay-close]');
    if (close) {
      var p = close.closest('[data-overlay]');
      if (p) { e.preventDefault(); p.setAttribute('data-state', 'closed'); document.documentElement.classList.remove('pr-lock'); }
      return;
    }
    if (t.closest('[data-cart-close]')) { e.preventDefault(); toggleCart(false); return; }
    var add = t.closest('[data-pr-add]');
    if (add) { e.preventDefault(); api.addToCart([{ id: add.getAttribute('data-pr-add'), quantity: 1 }], { button: add }); return; }
    var q = t.closest('[data-pr-qty]');
    if (q) {
      e.preventDefault();
      var line = q.closest('[data-pr-line]');
      busy(q, true);
      api.updateLine(line.getAttribute('data-pr-line'), { quantity: Math.max(0, Number(q.getAttribute('data-pr-qty'))) });
      return;
    }
    var mt = t.closest('[data-menu-trigger]');
    if (mt && window.matchMedia('(hover: none)').matches) {
      var m = mt.closest('[data-menu]');
      if (m && m.getAttribute('data-state') !== 'open') { e.preventDefault(); m.setAttribute('data-state', 'open'); }
    }
    // lien /cart -> tiroir
    var a = t.closest('a[href="/cart"]');
    if (a) { e.preventDefault(); toggleCart(true); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('[data-overlay][data-state="open"]').forEach(function (o) { o.setAttribute('data-state', 'closed'); });
    toggleCart(false);
    document.documentElement.classList.remove('pr-lock');
  });

  // menus deroulants (bureau)
  function menus() {
    document.querySelectorAll('[data-menu]').forEach(function (m) {
      if (m.__pr) return; m.__pr = true;
      var timer;
      m.addEventListener('mouseenter', function () { clearTimeout(timer); m.setAttribute('data-state', 'open'); });
      m.addEventListener('mouseleave', function () { timer = setTimeout(function () { m.setAttribute('data-state', 'closed'); }, 120); });
      m.addEventListener('focusin', function () { m.setAttribute('data-state', 'open'); });
      m.addEventListener('focusout', function (ev) { if (!m.contains(ev.relatedTarget)) m.setAttribute('data-state', 'closed'); });
    });
  }

  // en-tete collant
  function stuck() {
    document.querySelectorAll('[data-header-sticky]').forEach(function (h) {
      if (window.scrollY > 8) h.setAttribute('data-stuck', ''); else h.removeAttribute('data-stuck');
    });
  }
  window.addEventListener('scroll', stuck, { passive: true });

  document.addEventListener('DOMContentLoaded', function () {
    menus(); stuck();
    getCart().then(function (c) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = c.item_count; });
      reconcile(c);
    });
  });
  // retour arriere (bfcache) : le panier a pu changer
  window.addEventListener('pageshow', function (e) { if (e.persisted) sync(); });
})();
